// 応募(JobApplication)ステータス Badge の色。AdminJobApplicationTable(#1126)と JobApplicationList(#1120)で共有。
// 色は「進行中(brand) / 成約(green) / 不成立(red・gray)」の区別だけに使い、ステータスごとに色を増やさない。
export const JOB_APPLICATION_STATUS_COLORS = {
  applied: 'gray',
  screening: 'brand',
  proposed: 'brand',
  interview: 'brand',
  offered: 'brand',
  contracted: 'green',
  rejected: 'red',
  withdrawn: 'gray',
}

export function jobApplicationStatusColor(status) {
  return JOB_APPLICATION_STATUS_COLORS[status] || 'gray'
}
